
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Search from 'vux/src/components/search/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

import vSelect from './vselect'

export default {
components: {
Search,
XInput,
XButton,
Group,
Cell,
Selector,
vSelect,
XTable
},
data () {
return {
codets: '',
codets_list: [],
gname: '',
countryList: [],
country: null,
currencyList: [],
currency: '',
deliveryList: ['CIF', 'FOB', 'C&F', 'C&I'],
delivery: '',
unitPrice: null,
quantity: null,
total: null,
unit: '',
freight: null,
premium: null,
taxedTotalPrice: null,
taxPrice: null,
rate: null, /** 关税税率 **/
consumptionTax: null, /** 消费税税额 **/
addTax: null, /** 增值税税额 **/
AddedAvalueTax: '',
ImportPriceDuty: '',
exchange: null,
currencyName: '',
taxTotal: null,
expendResult: 1,
expendClass: 'fa fa-angle-double-up',
dropdownTitle: '收起说明',
CheckNumber: function (value) {
return {
valid: !isNaN(value) || value === null || value === '',
msg: '必数是数字'
}
}

}
},
methods: {
round (val) {
if (isNaN(val)) {
this.$vux.alert.show({title: '注意', content: val + '不是数字'})
return
}
return parseFloat(parseFloat(val).toFixed(2))
},
async OnSelectCountry (val) {
if (!val) {
return
}
console.log(val)
this.country = val
try {
await this.loadRate()
if (isNaN(this.rate) || this.rate === null || this.rate === '') {
this.$vux.alert.show({title: '注意', content: '不支持此种计税方式'})
return
}
} catch (err) {
this.$vux.alert.show({title: '注意', content: err.message})
}
},
async expend () {
if (this.expendClass === 'fa fa-angle-double-up') {
this.expendResult = 0
this.expendClass = 'fa fa-angle-double-down'
this.dropdownTitle = '展开说明'
return
}
try {
this.expendResult = 1
this.expendClass = 'fa fa-angle-double-up'
this.dropdownTitle = '收起说明'
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
async SearchCountry (search, loading) {
if (!search) {
return
}
try {
loading(true)
const countryListPromise = await this.$http.get('/API/HandBook/SearchCountry', {params: {keyword: search}})
this.countryList = countryListPromise.data
console.log(countryListPromise)
loading(false)
} catch (err) {
this.countryList = []
loading(false)
}
},
async OnSelectCodeTs (val) {
try {
if (!val) {

this.gname = ''
this.unit = ''
this.AddedAvalueTax = ''
return
}
this.codets = val
this.$vux.loading.show({text: ' 数据载入中'})
const GoodsInfo = await this.$http.get('/API/HandBook/GetNameUnitByCodeTs', {params: {codets: val}})
console.log(GoodsInfo.data)
if (GoodsInfo.data) {
this.gname = GoodsInfo.data.G_Name
this.unit = GoodsInfo.data.Unit
this.AddedAvalueTax = GoodsInfo.data.AddedAvalueTax
console.log(this.country)
if (this.country) {
await this.loadRate()
}
if (GoodsInfo.data.ImportPriceDuty && GoodsInfo.data.ImportSpecificDuty) {
this.ImportPriceDuty = GoodsInfo.data.ImportPriceDuty
}

if (!GoodsInfo.data.ImportPriceDuty && GoodsInfo.data.ImportSpecificDuty) {
this.$vux.alert.show({title: '注意', content: '此工具暂时不能作从量税、复合税的模拟计税,敬请谅解!'})
}

if (GoodsInfo.data.ImportPriceDuty && !GoodsInfo.data.ImportSpecificDuty) {
this.ImportPriceDuty = GoodsInfo.data.ImportPriceDuty
}
} else {
this.$vux.alert.show({title: '注意', content: '没找到商品编码'})
}
this.$vux.loading.hide()
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({title: '请求失败', content: err.message})
}
},
async getCodeTSList (search, loading) {
if (!search || search.length < 8) {
return
}
try {
loading(true)
const ratePromise = await this.$http.get('/API/HandBook/SearchCodeTS', {
params: {
codets: search
}
})
this.codets_list = ratePromise.data
loading(false)
} catch (err) {
this.codets_list = []
loading(false)
}
},
onCurrencyChange (val) {
this.exchange = parseFloat(this.currency.toString().split('@')[0])
this.currencyName = this.currency.toString().split('@')[1]
},
async loadRate () {
try {
const ratePromise = await this.$http.get('/API/HandBook/LoadRateByCountry', {
params: {
country: this.country.PC_Name_Ch,
codets: this.codets
}
})
this.rate = ratePromise.data
} catch (err) {
this.$vux.alert.show({title: '请求失败', content: err.message})
}
},
CalcCIF () {
this.taxedTotalPrice = this.total * this.exchange
return true
},
CalcFOB () {
if (!this.freight || isNaN(this.freight)) {
this.$vux.alert.show({title: '注意', content: '请输入运费'})
return false
}
if (!this.premium || isNaN(this.premium)) {
this.$vux.alert.show({title: '注意', content: '请输入保费'})
return false
}
this.taxedTotalPrice = (this.total + parseFloat(this.freight) + parseFloat(this.premium)) * this.exchange
return true
},
CalcCI () {
if (!this.freight || isNaN(this.freight)) {
this.$vux.alert.show({title: '注意', content: '请输入运费'})
return false
}
this.taxedTotalPrice = (this.total + parseFloat(this.freight)) * this.exchange
return true
},
CalcCF () {
if (!this.premium || isNaN(this.premium)) {
this.$vux.alert.show({title: '注意', content: '请输入保费'})
return false
}
this.taxedTotalPrice = (this.total + parseFloat(this.premium)) * this.exchange
return true
},
async Calc () {
if (!this.validate()) {
return false
}

if (!this.doCalcTaxedTotalPrice()) {
return false
}
this.taxedTotalPrice = this.round(this.taxedTotalPrice)
this.taxPrice = this.taxedTotalPrice * this.round(this.rate) / 100
this.taxPrice = this.round(this.taxPrice)

if (!this.ImportPriceDuty) {
this.ImportPriceDuty = 0
}
this.consumptionTax = (this.taxedTotalPrice + this.taxPrice) / (1 - parseFloat(this.ImportPriceDuty) / 100) * (parseFloat(this.ImportPriceDuty) / 100)
this.consumptionTax = this.round(this.consumptionTax)

this.addTax = (this.taxedTotalPrice + this.taxPrice + this.consumptionTax) * (parseFloat(this.AddedAvalueTax) / 100)
this.addTax = this.round(this.addTax)
this.taxTotal = this.round(this.taxPrice + this.consumptionTax + this.addTax)
},
async doCalcTaxedTotalPrice () {
console.log(this.delivery)
if (this.delivery === 'CIF') {
return this.CalcCIF()
}
if (this.delivery === 'FOB') {
return this.CalcFOB()
}
if (this.delivery === 'C&F') {
return this.CalcCF()
}
if (this.delivery === 'C&I') {
return this.CalcCI()
}
},
validate () {
if (!this.country) {
this.$vux.alert.show({title: '注意', content: '请选择原产地'})
return false
}
if (!this.gname) {
this.$vux.alert.show({title: '注意', content: '请输入商品编码'})
return false
}
if (!this.currency) {
this.$vux.alert.show({title: '注意', content: '请选择币制'})
return false
}
if (!this.delivery) {
this.$vux.alert.show({title: '注意', content: '请选择成交方式'})
return false
}
if (!this.total) {
this.$vux.alert.show({title: '注意', content: '请输入总价'})
this.total = this.round(this.total)
return false
}




return true
}
},
async activated () {
try {
this.$vux.loading.show({text: ' 数据载入中'})
const currencyListPromise = await this.$http.get('/API/HandBook/LoadAllCurrency')
this.currencyList = currencyListPromise.data
this.$vux.loading.hide()
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({title: '请求失败', content: err.message})
}
},
computed: {
freightPlaceHolder: function () {
if (this.delivery === 'CIF' || this.delivery === 'C&F') {
return '不可输入'
} else {
return '请输入运费'
}
},
premiumPlaceHolder: function () {
if (this.delivery === 'CIF' || this.delivery === 'C&I') {
return '不可输入'
} else {
return '请输入保费'
}
},
total: function () {
return this.round(this.unitPrice * this.quantity)
}
}
}



// WEBPACK FOOTER //
// ./src/components/TaxCalculator.vue